import { gql } from "@/__generated__/gql";

export const BULK_MESSAGE_PROPOSAL = gql(`
  query ProposeBulkMessage(
      $orgId: ID!,
      $imageSize: Int = 40,
      $filters: BulkMessageFilterInput!
    ) {
    node(id: $orgId) {
      ... on Organization {
        id
        __typename
        bulkMessageProposal(proposal: { filters: $filters }) {
          ... on BulkMessageFilterProposal {
            students {
              edges {
                node {
                  id
                  uuid
                  firstName
                  lastName
                  profilePhoto {
                    id
                    url(size: $imageSize)
                  }
                }
              }
              totalCount
            }
          }
        }
      }
    }
  }
`);

export const BULK_MESSAGE_CSV_PROPOSAL = gql(`
  query ProposeBulkMessageCsv(
    $orgId: ID!,
    $imageSize: Int = 40,
    $csvFile: Upload!
  ) {
    node(id: $orgId) {
      ... on Organization {
        id
        __typename
        bulkMessageProposal(
          proposal: { csvFile: $csvFile }
        ) {
          ... on BulkMessageCsvProposal {
            students {
              edges {
                node {
                  id
                  uuid
                  firstName
                  lastName
                  profilePhoto {
                    id
                    url(size: $imageSize)
                  }
                }
              }
              totalCount
            }
            missingStudentIds
          }
        }
      }
    }
  }
`);
